export default "__VITE_ASSET__gsk6GHu6__"